import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostBinding,
    Inject,
    OnInit,
    Output,
    ViewChild,
    Input,
    effect,
    AfterViewInit,
    OnDestroy,
    ElementRef,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DialogService } from "src/app/services/dialog/dialog.service";
import { AddressComponent } from "src/app/user-details/address/address.component";
import { ProfileDetailsComponent } from "src/app/user-details/profile-details/profile-details.component";
import { BaseAddress, NullableAddresses, BaseUser } from "@models/user.model";
import { OperationsModel } from "@models/order.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ReviewStatus } from "@models/admin.model";
import { noSpacesValidator } from "../shared/no-leading-space-validator.directive";
import { DialogInvokingComponents } from "@models/generic-dialog.model";
import { ButtonData, StructureInstance, StructureStatus, StructureBaseModel } from "@models/structure.model";
import { ifscValidator } from "../ifsc-validator.directive";
import { indianBankAccountValidator } from "../account-number-validator.directive";
import { StructureService } from "../../services/structure/structure.service";
import { finalize, Subject, Subscription, takeUntil } from "rxjs";
import { upiValidator } from "../upiId-validator.directive";
import { accountHolderNameValidator } from "../account-holder-name.validator";
import Swiper from "swiper";
import { DesignerTourSteps, MyIStepOption } from "../models/designer-tour.model";
import { CustomTourService } from "../../services/custom-tour.service";
import { LoginPageService } from "../../services/login-page.service";
import { AuthService } from "../../services/auth/auth.service";
import { CartItemService } from "../../services/cart-item/cart-item.service";
import { UserService } from "../../services/user/user.service";
import { Router } from "@angular/router";
import { CouponAttributes, CouponsMessage } from "@models/coupon.model";
import { PaymentMethod } from "@models/payment.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackBarConfig } from "../../constants/snackbar.constants";
import { RouteTrackingService } from "../../services/route-tracking/route-tracking.service";
import { SupportMessage } from "@models/support-chat.model";
import { SupportSocketService } from "../../services/support-chat/support-socket.service";
import { SupportChatApiService } from "../../services/support-chat/support-chat-api.service";
import { AdminService } from "../../services/admin/admin.service";

interface ImageData {
    image: string; // URL of the image
    thumbImage: string; // URL of the thumbnail (if needed)
}

enum LoginState {
    Mobile = "Mobile",
    Otp = "Otp",
    Success = "Success",
    Failure = "Failure",
}
type Timeout = ReturnType<typeof setTimeout>;
@Component({
    selector: "app-generic-dialog",
    templateUrl: "./generic-dialog.component.html",
    styleUrls: ["./generic-dialog.component.scss"],
    standalone: false,
})
export class GenericDialogComponent implements OnInit, AfterViewInit, OnDestroy {
    public DialogInvokingComponents = DialogInvokingComponents;
    public address!: BaseAddress;
    public profile!: BaseUser;
    public courierForm!: FormGroup;
    public saveStructureForm!: FormGroup;
    public returnOrderForm!: FormGroup;
    public productReviewForm!: FormGroup;
    public todayDate = new Date();
    public sliderImageSize = { width: "100%", height: "400px" };
    public myStructureListForm: FormGroup;
    // public selectedCoupons: number[] = [];
    public selectedOption: string = "";
    public displayedColumns: string[] = ["name", "count"];
    public dataSource: any;
    public totalShape!: number;
    public minutes = 5;
    public seconds = 0;
    public isSubmitting: boolean = false;
    public isOtpCorrect: boolean = false;
    public showResendLink = false;
    public showOTPField = false;
    public showTimer = false;
    public timerInterval: Timeout | undefined;
    public otpFailedMessage!: string;
    public myStructureStatus = [
        { name: "Saved", value: StructureStatus.Saved },
        { name: "Publish", value: StructureStatus.Published },
        { name: "Approved", value: StructureStatus.Approved },
        { name: "Rejected", value: StructureStatus.Rejected },
    ];
    public filteredSteps: {
        step: MyIStepOption;
        label: string;
    }[] = [];

    public structures: { count: number; rows: StructureInstance[] } = { count: 0, rows: [] };
    public pagination = {
        pageSize: 10,
        currentPage: 0,
        totalItems: 0,
    };
    public searchTerm: string = "";
    public isLoading = false;
    public buttonData = ButtonData;
    public loginForm!: FormGroup;
    public loginState: LoginState = LoginState.Mobile;
    public LoginState = LoginState;
    public PaymentMethod = PaymentMethod;
    public isCoinUsed: boolean = false;
    public messages!: SupportMessage[];
    @Output() coinUsedChange = new EventEmitter<boolean>();

    @Output() saveClicked: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild(AddressComponent) addressDetailsRef: AddressComponent | undefined;
    @ViewChild(ProfileDetailsComponent) profileDetailRef: ProfileDetailsComponent | undefined;
    @ViewChild("messageContainer") private messageContainer?: ElementRef<HTMLDivElement>;
    @HostBinding("class.dialog-mode") isInDialog: boolean = true;
    @Input() glbUrl!: string;
    public swiper!: Swiper;
    public hasCompletedTour: boolean = false;
    public selectedPayment: string = this.PaymentMethod.OnlinePayment;
    public helpQuery: string = "";
    private socketSubscriptions = new Subscription();
    private destroy$ = new Subject<void>();
    public isUserloggedIn: boolean = false;
    public reviewStatus = ReviewStatus;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            componentName: string;
            content: string;
            content2: string;
            inputs: OperationsModel[];
            inputs2: OperationsModel[];
            inputs3: OperationsModel[];
            refundtype: string;
            showTextArea: boolean;
            firstBtn: string;
            secondBtn: string;
            image: string;
            addresses: NullableAddresses;
            addressId: number;
            withUserProfileDetails?: boolean;
            hideAgeAndShowMobile: boolean;
            imageSlider: ImageData[];
            structureName: string;
            structureDescription: string;
            status: string;
            message: string;
            isPublish: boolean;
            // activeCoupon: CouponAttributes[];
            options: any;
            value: number;
            glbUrl: string;
            isDesigner: boolean;
            availableCoupons: CouponAttributes[];
            totalCoinBalance: number;
            totalAmount: number;
            isCoinUsed: boolean;
            publicId: string;
            sessionStatus: string;
            adminId: number;
        },
        public dialogRef: MatDialogRef<GenericDialogComponent>,
        private dialogService: DialogService,
        private formBuilder: FormBuilder,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private structureService: StructureService,
        private customTourService: CustomTourService,
        private loginService: LoginPageService,
        private authService: AuthService,
        private cartItemService: CartItemService,
        private userService: UserService,
        private router: Router,
        private snackBar: MatSnackBar,
        private routeTrackingService: RouteTrackingService,
        private readonly supportChatApiService: SupportChatApiService,
        private readonly socketService: SupportSocketService,
        private adminService: AdminService,
    ) {
        this.data.withUserProfileDetails = this.data.withUserProfileDetails ?? true;
        this.data.hideAgeAndShowMobile = this.data.hideAgeAndShowMobile ?? false;
        this.myStructureListForm = this.formBuilder.group({
            myStructureName: ["", [Validators.required, noSpacesValidator()]],
            myStructureDescription: ["", [Validators.required, noSpacesValidator()]],
            status: [""],
        });

        effect(() => {
            this.hasCompletedTour = this.customTourService.hasCompletedTour();
        });

        this.socketService.connectAdmin(this.data.publicId);

        this.socketService
            .onMessage()
            .pipe(takeUntil(this.destroy$))
            .subscribe(({ message }) => {
                this.messages = [...this.messages, message];
                this.cdr.markForCheck();
                this.scrollToBottom();
            });

        this.socketService
            .onSessionUpdate()
            .pipe(takeUntil(this.destroy$))
            .subscribe((update) => {
                if (update.status === "ACTIVE") {
                    this.loadSessionMessages(this.data.publicId);
                    this.cdr.markForCheck();
                    this.scrollToBottom();
                }
            });
    }

    ngOnInit(): void {
        this.isUserloggedIn = this.authService.isUserLoggedIn;
        this.dataSource = this.data.options;
        this.isCoinUsed = this.data.isCoinUsed;
        this.filteredSteps = this.customTourService.designerTourSteps;
        this.courierForm = this.formBuilder.group({});
        this.data.inputs?.forEach((input) => {
            const validators = [Validators.required];
            if (input.type !== "date") {
                validators.push(noSpacesValidator());
            }
            this.courierForm.addControl(input.controlName, this.formBuilder.control(input.value, validators));
        });

        if (this.data.componentName === DialogInvokingComponents.StructureDetails) {
            this.saveStructureForm = this.formBuilder.group({
                structureName: [
                    this.data.structureName ? this.data.structureName : "",
                    [Validators.required, noSpacesValidator()],
                ],
                structureDescription: [
                    this.data.structureDescription ? this.data.structureDescription : "",
                    [Validators.required, noSpacesValidator()],
                ],
            });
        } else if (this.data.componentName === DialogInvokingComponents.MyStructuresListProperties) {
            if (
                [StructureStatus.Published, StructureStatus.Approved, StructureStatus.Rejected].includes(
                    this.data.status as StructureStatus,
                )
            ) {
                this.myStructureListForm.disable();
            }
            this.myStructureListForm.get("myStructureName")?.setValue(this.data?.structureName);
            this.myStructureListForm.get("myStructureDescription")?.setValue(this.data?.structureDescription);
            this.myStructureListForm.get("status")?.setValue(this.data?.status);
        }

        if (this.data.componentName === DialogInvokingComponents.ReturnOrderCod) {
            this.returnOrderForm = this.formBuilder.group({
                reason: ["", [Validators.required]],
                refundOption: ["bankDetails", [Validators.required]],
                bankDetails: this.formBuilder.group({
                    accountHolderName: ["", []],
                    accountNumber: ["", []],
                    ifscCode: ["", []],
                }),
                upi: this.formBuilder.group({
                    upiId: ["", []],
                }),
            });

            this.returnOrderForm.get("refundOption")?.valueChanges.subscribe((value) => {
                if (value === "bankDetails") {
                    this.setBankDetailsValidators();
                    this.clearUpiValidators();
                    this.returnOrderForm.get("upi")?.reset();
                } else if (value === "upi") {
                    this.setUpiValidators();
                    this.clearBankDetailsValidators();
                    this.returnOrderForm.get("bankDetails")?.reset();
                }
                this.cdr.detectChanges();
            });

            // Trigger the initial setup
            this.returnOrderForm.get("refundOption")?.updateValueAndValidity();
        }

        if (this.data.componentName === DialogInvokingComponents.LoadMyStructures) {
            this.isLoading = true;
            let pageIndex = 0;
            this.fetchStructures(pageIndex);
        }

        if (this.data.componentName === DialogInvokingComponents.ChatDialog) {
            this.loadSessionMessages(this.data.publicId);
        }

        if (this.data.componentName === DialogInvokingComponents.ProductReview) {
            this.productReviewForm = this.formBuilder.group({
                action: ["", [Validators.required]],
                reason: [""],
            });

            this.productReviewForm.get("action")?.valueChanges.subscribe((value) => {
                if (value === ReviewStatus.Rejected) {
                    this.productReviewForm.get("reason")?.setValidators([Validators.required]);
                } else {
                    this.productReviewForm.get("reason")?.clearValidators();
                }
                this.productReviewForm.get("reason")?.updateValueAndValidity();
            });
        }
    }
    /*** Filter out alphabet character ***/
    private filterNumeric(value: string): string {
        return value.replace(/\D/g, "");
    }

    ngAfterViewInit(): void {
        this.swiper = new Swiper(".swiper-container", {
            slidesPerView: 1,
            loop: this.data.imageSlider?.length > 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                disabledClass: "swiper-button-disabled",
            },
        });
    }

    public goToNextSlide() {
        this.swiper.slideNext();
    }

    public goToPrevSlide() {
        this.swiper.slidePrev();
    }

    private fetchStructures(pageIndex: number = 0, searchTerm: string = ""): void {
        this.isLoading = true; // Show loading state
        const offset = pageIndex * (this.pagination?.pageSize || 10);
        this.structureService
            .getSavedStructures(offset, this.pagination?.pageSize || 10, searchTerm)
            .pipe(finalize(() => (this.isLoading = false))) // Runs in all cases
            .subscribe({
                next: (structures) => {
                    this.structures = structures;
                    this.pagination = {
                        pageSize: this.pagination?.pageSize || 10,
                        currentPage: pageIndex,
                        totalItems: structures.count,
                    };
                },
            });
    }

    public changePage(page: number): void {
        if (page < 0 || page > this.getPageCount()) return;

        this.fetchStructures(page);
        this.pagination.currentPage = page;
    }

    public getPageCount(): number {
        return Math.ceil(this.pagination.totalItems / this.pagination.pageSize);
    }

    public selectStructure(structureId: number): void {
        this.dialogRef.close(structureId);
    }

    public searchStructures(term: string): void {
        // Reset to first page when searching
        this.pagination.currentPage = 0;

        // Call your service method to fetch structures with the search query
        this.fetchStructures(this.pagination.currentPage, term);
    }

    public setBankDetailsValidators(): void {
        const bankDetails = this.returnOrderForm.get("bankDetails");
        bankDetails?.get("accountHolderName")?.setValidators([Validators.required, accountHolderNameValidator()]);
        bankDetails?.get("accountNumber")?.setValidators([Validators.required, indianBankAccountValidator()]);
        bankDetails?.get("ifscCode")?.setValidators([Validators.required, ifscValidator()]);
        bankDetails?.updateValueAndValidity();
    }

    public clearBankDetailsValidators(): void {
        const bankDetails = this.returnOrderForm.get("bankDetails");
        bankDetails?.get("accountHolderName")?.clearValidators();
        bankDetails?.get("accountNumber")?.clearValidators();
        bankDetails?.get("ifscCode")?.clearValidators();
        bankDetails?.updateValueAndValidity();
    }

    public setUpiValidators(): void {
        const upi = this.returnOrderForm.get("upi");
        upi?.get("upiId")?.setValidators([Validators.required, upiValidator()]);
        upi?.updateValueAndValidity();
    }

    public clearUpiValidators(): void {
        const upi = this.returnOrderForm.get("upi");
        upi?.get("upiId")?.clearValidators();
        upi?.updateValueAndValidity();
    }

    public onAddressChange(): void {
        this.dialogRef.close(this.data.addressId);
    }

    public onAddAddress(): void {
        const data = {
            componentName: DialogInvokingComponents.AddAddress,
            title: "Add Delivery Address",
            withUserProfileDetails: false,
        };
        this.dialogService.openDialog(data);
    }

    public closeDialog(): void {
        this.dialogRef.close("");
    }

    public receiveAddressData(address: BaseAddress): void {
        this.address = address;
    }

    public receiveProfileData(profile: BaseUser): void {
        this.profile = profile;
    }

    public isFormDataValid(): boolean {
        if (this.data.withUserProfileDetails) {
            const profileFormValid =
                this.profileDetailRef?.profileForm.valid && this.profileDetailRef?.profileForm.dirty;
            const addressFormValid =
                this.addressDetailsRef?.addressForm.valid && this.addressDetailsRef?.addressForm.dirty;
            return !!(profileFormValid && addressFormValid);
        } else {
            const addressFormValid =
                this.addressDetailsRef?.addressForm.valid && this.addressDetailsRef?.addressForm.dirty;
            return !!addressFormValid;
        }
    }

    private trimSpaces(): void {
        const trimControl = (controlName: string) => {
            const control = this.courierForm.get(controlName);
            if (control) {
                control.setValue(control.value.trim());
            }
        };

        this.data.inputs.forEach((input) => {
            if (input.type !== "date") {
                trimControl(input.controlName);
            }
        });
    }

    public isInvalid(form: FormGroup, controlName: string, validatorName?: string): boolean {
        const control = form.get(controlName);
        if (validatorName) {
            return control!.errors?.[validatorName];
        }
        return control!.invalid && control!.touched;
    }

    public save(): void {
        this.trimSpaces();
        if (this.courierForm.valid) {
            const data = this.courierForm.value;
            this.saveClicked.emit(data);
            this.dialogRef.close();
        }
    }

    onConfirm(): void {
        if (this.selectedOption) {
            this.saveClicked.emit(this.selectedOption);
            this.dialogRef.close();
        }
    }

    public updateStructureData(): void {
        const structureData: StructureBaseModel = {
            structureName: this.myStructureListForm.get("myStructureName")?.value.trim(),
            structureDescription: this.myStructureListForm.get("myStructureDescription")?.value.trim(),
            status: this.myStructureListForm.get("status")?.value.trim(),
        };
        this.dialogRef.close(structureData);
    }

    public disableStatus(statusValue: StructureStatus): boolean {
        if (this.data.status === StructureStatus.Saved) {
            return statusValue !== StructureStatus.Published;
        }
        return true;
    }

    public isStatusDisabled(): boolean {
        return [StructureStatus.Published, StructureStatus.Approved, StructureStatus.Rejected].includes(
            this.data.status as StructureStatus,
        );
    }

    public closeDialogPublish(): void {
        this.dialogRef.close(true);
    }

    public confirmationDialog(): void {
        if (this.data.componentName === DialogInvokingComponents.StructureDetails && this.data.isPublish) {
            const dialogRef = this.dialog.open(GenericDialogComponent, {
                disableClose: true,
                data: {
                    componentName: DialogInvokingComponents.MyStructuresList,
                    title: "Publish My Structure",
                    content:
                        "Are you sure you want to publish this structure? Once published, it will be visible to all users after admin approval.",
                    firstBtn: "Publish",
                    secondBtn: "Cancel",
                    isActionOnEnter: true,
                },
                autoFocus: false,
                restoreFocus: false,
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this.dialogRef.close(this.saveStructureForm.value);
                    this.saveStructureForm.reset();
                }
            });
        } else {
            this.dialogRef.close(this.saveStructureForm.value);
            this.saveStructureForm.reset();
        }
    }

    public returnOrderData(): void {
        const data = this.returnOrderForm.value;
        this.saveClicked.emit(data);
    }

    // public toggleSelection(element: CouponAttributes, event: any): void {
    //     if (event.checked) {
    //         this.selectedCoupons.push(element.id!); // Assuming element.id is a number
    //     } else {
    //         const index = this.selectedCoupons.indexOf(element.id!);
    //         if (index > -1) {
    //             this.selectedCoupons.splice(index, 1);
    //         }
    //     }
    // }

    // public applyCoupon(): void {
    //     this.dialogRef.close(this.selectedCoupons);
    // }

    public isOverflow(el: HTMLElement): boolean {
        var curOverflow = el.style.overflow;
        if (!curOverflow || curOverflow === "visible") {
            el.style.overflow = "hidden";
        }
        var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
        el.style.overflow = curOverflow;
        return isOverflowing;
    }

    public onStepClicked(step: MyIStepOption): void {
        this.dialogRef.close("");
        this.customTourService.isDirectTourSearchSignal.set(true);

        const stepsWithActions = [
            DesignerTourSteps.flips.stepId,
            DesignerTourSteps.colourPicker.stepId,
            DesignerTourSteps.getCount.stepId,
            DesignerTourSteps.totalBlocks.stepId,
            DesignerTourSteps.saveButton.stepId,
            DesignerTourSteps.publishButton.stepId,
            DesignerTourSteps.loadButton.stepId,
        ];

        if (stepsWithActions.includes(step.stepId)) {
            this.customTourService.openActions();
        }

        this.customTourService.startAt(step.stepId!);
    }

    onOtpChange(otp: string): void {
        // If OTP input is cleared or empty, reset the form control and stop further processing.
        if (!otp) {
            this.loginForm.get("otp")?.setValue("");
            return;
        }
        this.loginForm.get("otp")?.setValue(otp);

        if (otp.length === 6) {
            this.onSubmit();
        }
    }

    public onSubmit(): void {
        // Do NOT submit if resend link is visible (means OTP expired)
        if (this.showResendLink) return;

        if (this.loginForm.invalid) {
            this.loginForm.markAllAsTouched();
            return;
        }
        this.isSubmitting = true;
        if (this.loginState === LoginState.Mobile) {
            // Stage 1: Send OTP
            const body = {
                mobileNumber: this.loginForm.value.mobileNumber,
            };

            this.loginService.sendOTP(body).subscribe({
                next: (res) => {
                    this.loginState = LoginState.Otp;
                    this.isSubmitting = false;
                    this.showOTPField = true;
                    this.showResendLink = false;
                    this.showTimer = true;
                    this.startTimer();
                },
                error: (err) => {
                    this.isSubmitting = false;
                    throw new Error();
                },
            });
        } else {
            if (!this.loginForm.value.otp) {
                this.isSubmitting = false;
                return;
            }
            const verifyBody = {
                mobileNumber: this.loginForm.value.mobileNumber,
                otp: this.loginForm.value.otp,
            };

            this.loginService.verifyOtp(verifyBody).subscribe({
                next: (res) => {
                    if (!res.success) {
                        this.loginForm.get("otp")?.setErrors({
                            customError: res.message,
                        });
                        //lines based on previous ui so not erasing
                        //this.loginState = LoginState.Failure;
                        this.isSubmitting = false;
                        this.isOtpCorrect = false;
                        this.otpFailedMessage = "Invalid OTP. Please check your code and try again.";
                        return;
                    } else if (res.success) {
                        //lines based on previous ui so not erasing
                        //this.loginState = LoginState.Success;
                        this.isOtpCorrect = true;
                        this.dialogRef.close("true");
                    }

                    const token = res.token!;
                    localStorage.setItem("token", token);
                    this.authService.checkLoginStatus();
                    this.cartItemService.processCartItems(true);
                    this.loginForm.get("otp")?.setErrors(null);
                    this.loginContinue();
                },
                error: (err) => {
                    throw new Error();
                },
            });
        }
    }

    public loginContinue(): void {
        this.userService.isUserDetailsExist().subscribe((response) => {
            if (!response) {
                this.router.navigate(["/userDetails"]);
            } else {
                this.routeTrackingService.redirectingCurrentUrl();
            }
        });
    }

    public continueAsGuest() {
        this.dialogRef.close(false);
    }

    /** Checking OTP Input Field **/
    public isInputFieldInValid(): boolean {
        const otp = this.loginForm.get("otp")?.value;
        return !otp || otp.length !== 6;
    }

    private openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            ...SnackBarConfig.Defaults,
        });
    }

    public copyToClipboard(couponCode: string) {
        navigator.clipboard.writeText(couponCode).then(() => {
            this.openSnackBar(CouponsMessage.Copied, SnackBarConfig.Actions.OKAY);
        });
    }

    public onCoinToggle() {
        this.coinUsedChange.emit(this.isCoinUsed);
    }

    public startTimer(): void {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }

        this.minutes = 5;
        this.seconds = 0;

        this.timerInterval = setInterval(() => {
            if (this.minutes === 0 && this.seconds === 0) {
                clearInterval(this.timerInterval);
                this.showTimer = false;
                this.showResendLink = true;
                return;
            }
            if (this.seconds === 0) {
                this.minutes--;
                this.seconds = 59;
            } else {
                this.seconds--;
            }
        }, 1000);
    }

    get timerDuration(): string {
        const min = this.minutes > 9 ? `${this.minutes}` : `0${this.minutes}`;
        const sec = this.seconds > 9 ? `${this.seconds}` : `0${this.seconds}`;
        return `OTP expires in ${min}:${sec}`;
    }

    public resendOTP(): void {
        this.isOtpCorrect = true;
        const requestBody = {
            mobileNumber: this.loginForm.value.mobileNumber,
        };
        this.loginService.resendOtp(requestBody).subscribe(
            () => {
                this.showTimer = true;
                this.minutes = 5;
                this.startTimer();
                this.isSubmitting = false;
                this.showResendLink = false;
            },
            (error) => {},
        );
    }

    ngOnDestroy(): void {
        clearInterval(this.timerInterval);
        this.destroy$.next();
        this.destroy$.complete();
    }

    public getMessageClass(message: SupportMessage): string {
        // Check if it's an AI history message
        if (message.metadata?.isAiHistory) {
            return message.metadata.originalSender === "assistant" ? "ai-assistant" : "user";
        }
        return message.senderType;
    }

    public loadSessionMessages(publicId: string): void {
        this.adminService.getSession(publicId).subscribe((response) => {
            this.messages = response.messages!;
        });
    }

    private scrollToBottom(): void {
        // Use requestAnimationFrame and setTimeout for reliable scrolling
        requestAnimationFrame(() => {
            setTimeout(() => {
                const container = this.messageContainer?.nativeElement;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            }, 0);
        });
    }
}
